import Vue from 'vue'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import relativeTime from 'dayjs/plugin/relativeTime'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import 'dayjs/locale/es'
import { DateTime } from 'luxon'

// Extend Day.js with plugins
dayjs.extend(advancedFormat)
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(localizedFormat)
dayjs.extend(relativeTime)
dayjs.locale('es')

Vue.filter('moment', function(value, format = 'DD/MM/YYYY') {
  return dayjs(value).format(format)
})

Vue.filter('dbDateToFormat', (value, format) => {
  return DateTime.fromISO(value, { setZone: true }).toFormat(format)
})

Vue.filter('jsDateToFormat', (value, format) => {
  return DateTime.fromJSDate(value, { setZone: true }).toFormat(format)
})

Vue.filter('dayAbbreviation', (value, locale = 'en') => {
  return DateTime.fromJSDate(value, { setZone: true })
    .setLocale(locale)
    .toFormat('ccc')
    .toLocaleLowerCase()
})

//Vue.filter('dbDateToJs', (value, format) => {

//})

Vue.filter('dbDateUTCToGMTlocal', (value, format = 'DD/MM/YYYY HH:mm') => {
  return dayjs(value).format(format)
})

Vue.filter('dateToFullDate', (date) => {
  if (!date) return null
  return dayjs(date).toDate()
})

Vue.filter('UTCDateFormatter', (date, format = '-') => {
  return dayjs.utc(date).format(`DD${format}MM${format}YYYY`)
})

Vue.filter('title', (value, replacer = '_') => {
  if (!value) return ''
  value = value.toString()
  const arr = value.split(replacer)
  const capitalized_array = []
  arr.map((word) => {
    const capitalized = word.charAt(0).toUpperCase() + word.slice(1)
    capitalized_array.push(capitalized)
  })
  return capitalized_array.join(' ')
})

Vue.filter('currency', (value, decimals = 0, prefix = '', suffix = '', conditionalDecimals = false) => {
  //Filtro usado para visualizar información de moneda. Para elementos input, debe usarse currencyMask del archivo masks.js
  if (!value && ![0, '0'].includes(value)) return ''
  const decFixed = (value / 1).toFixed(decimals)
  const val = (conditionalDecimals && decFixed.split('.')[1] === '00') ? decFixed.split('.')[0]  : decFixed.replace('.', ',')
  return `${prefix}${val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}${suffix}`
})
Vue.filter('currencySymbol', (country) => {
  //Filtro usado para obtener el simbolo de la moneda de cada país!.
  const currencySimbol = {
    cl: '$',
    co: '$',
    pe: 'S/',
    mx: '$'
  }
  return currencySimbol[country.toLowerCase()]
})

Vue.filter('monthName', (date) => {
  const monthNames = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
  const dateParse = new Date(date)
  return monthNames[dateParse.getMonth()]
})

Vue.filter('monthNamePreviousMonth', (date) => {
  const monthNames = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
  const dateParse = new Date(date)
  dateParse.setMonth(dateParse.getMonth() - 1)
  return monthNames[dateParse.getMonth()]
})

Vue.filter('formatByte', (bytes, decimals = 2) => {
  if (bytes === 0) return '0 B'
  const i = Math.floor(Math.log(bytes) / Math.log(1024))
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  return `${(bytes / Math.pow(1024, i)).toFixed(decimals) * 1} ${sizes[i]}`
})

Vue.filter('formatRut', (rut) => {
  //Filtro para formatear el rut
  const value = rut.replace(/[^A-Za-z0-9]+/g, '')
  return `${value.slice(0, -1)}-${value.slice(-1).toUpperCase()}`
})

Vue.filter('momentSubtract', (days = 0, time = 'days') => {
  return dayjs().subtract(days, time).toDate()
})

Vue.filter('momentAdd', (days = 0, time = 'days') => {
  return dayjs().add(days, time).toDate()
})


Vue.filter('countryLevels', () => {
  return Object.freeze({ //Esto lo tome literalmente de un switch case en platform
    1: null,
    2: 5,
    3: 16,
    4: 10,
    5: 20,
    6: 23
  })
})


Vue.filter('getStatusClasses', () => {
  //variables con los nombres de las clases para escribirlos una sola vez
  const classes = Object.freeze({
    default: 'table_dot--state-creado',
    blue: {
      lightest: 'table_dot--state-progress',
      lighter: 'table_dot--state-progress2',
      light: 'table_dot--state-progress3',
      dark:'table_dot--state-progress4',
      darker:'table_dot--state-progress5',
      darkest:'table_dot--state-progress6'
    },
    red: 'table_dot--state-incidence',
    green: 'table_dot--state-ok',
    yellow: {
      lightest: 'table_dot--state-warning',
      light: 'table_dot--state-warning2',
      dark:'table_dot--state-warning3',
      darkest:'table_dot--state-warning4'
    }
  })
  //Retorna el objeto con los id y sus clases respectivas
  return {
    /****
     * Estatus en DEFAULT - GRIS
     ****/
    1: classes.default, //Creado
    /****
     * Estatus en PROGRESO - AZUL
     ****/
    5: classes.blue.lightest, //Listo para despacho
    62:classes.blue.lightest, //Listo para despacho
    26:classes.blue.lighter, //Listo para despacho - Impreso
    63:classes.blue.lighter, //Listo para despacho - Impreso
    3: classes.blue.light, //Enviado a Carrier
    57:classes.blue.light, //Entregado a Carrier
    66:classes.blue.light, //Para entregar a fulfillment
    67:classes.blue.light, //Entregado a fulfillment
    16:classes.blue.light, //Retirado por carrier
    75:classes.blue.dark, //Manifiesto confirmado
    6: classes.blue.darker, //En planta de origen
    7: classes.blue.darker, //En tránsito
    8: classes.blue.darker, //En planta de destino
    2: classes.blue.darker, //Procesando
    36:classes.blue.darker, //Gestión en proceso
    47:classes.blue.darkest, //Asignado
    68:classes.blue.darkest, //Asignado a repartidor
    9: classes.blue.darkest, //En Reparto
    34:classes.blue.darkest, //Solucionado y enviando a destinatario
    45:classes.blue.darkest, //Admitido en Sucursal/Agencia
    65:classes.blue.darkest, //Paquete listo para ser retirado
    11:classes.blue.darkest, //Disponible para retiro
    50:classes.blue.darkest, //Entrega parcial
    /****
     * Estatus en INCIDENCIAS - ROJO
     ****/
    4: classes.red, //Rechazado por Carrier
    12:classes.red, //Eliminado
    17:classes.red, //Dirección no encontrada
    18:classes.red, //Rechazado por destinatario
    19:classes.red, //No hay quien reciba
    20:classes.red, //Envío dañado
    21:classes.red, //Envío extraviado
    22:classes.red, //Envío extraviado
    23:classes.red, //Pendiente
    24:classes.red, //Extraviado
    25:classes.red, //Transporte sin acceso
    27:classes.red, //Envío no pudo ser entregado
    29:classes.red, //Expirado
    32:classes.red, //Devolucion no retirada por carrier
    35:classes.red, //Destinatario desconocido
    37:classes.red, //Pendiente - requiere solución
    38:classes.red, //Presuntamente Extraviado
    39:classes.red, //Destinatario cambió de dirección
    40:classes.red, //Envío retenido
    41:classes.red, //Entrega fallida
    43:classes.red, //Devolución cancelada
    46:classes.red, //Dirección incorrecta
    48:classes.red, //Extraviado - Sin movimiento
    49:classes.red, //Anulado
    51:classes.red, //Incumplimiento de servicio
    52:classes.red, //Fuera de cobertura
    53:classes.red, //No retirado - Incidencia seller
    54:classes.red, //Pronto a Expirar
    56:classes.red, //Expirado en tienda
    64:classes.red, //Retraso por fuerza mayor
    76:classes.red, //Destinatario se rehusa a pagar
    /****
     * Estatus en OK - VERDE
     ****/
    10:classes.green, //Entregado
    13:classes.green, //Retirado por cliente
    /****
     * Estatus en WARNING - AMARILLO
     ****/
    14:classes.yellow.lightest, //Devolucion
    70:classes.yellow.lightest, //Devolución parcial
    71:classes.yellow.lightest, //Devolución parcial
    55:classes.yellow.light, //Iniciar devolución
    44:classes.yellow.light, //Devolución a remitente
    31:classes.yellow.dark, //Devolucion retirada por carrier
    33:classes.yellow.dark, //Devolucion en reparto
    30:classes.yellow.darkest //Devolucion entregada
  }
})

Vue.filter('humanizeExpirationDate', (date, format) => {
  if (!date) return null
  const today = new Date()
  const targetDate = new Date(date)
  const oneYear = 31536000000
  const oneMonth = 2628000000
  const oneDay = 86400000

  let difference = targetDate - today

  if (difference < 0) {
    return 'La fecha ya ha pasado.'
  } else if (difference === 0) {
    return 'Es hoy!'
  }

  const years = Math.floor(difference / oneYear)
  difference -= years * oneYear
  const months = Math.floor(difference / oneMonth)
  difference -= months * oneMonth
  const days = Math.floor(difference / oneDay)

  const timeUnits = [
    { quantity: years, singularTime: 'año', pluralTime: 'años' },
    { quantity: months, singularTime: 'mes', pluralTime: 'meses' },
    { quantity: days, singularTime: 'día', pluralTime: 'días' }
  ]
  const formattedDate = timeUnits.filter(time => time.quantity > 0).map(time => `${time.quantity} ${time.quantity > 1 ? time.pluralTime : time.singularTime}`).join(' ')

  return formattedDate.trim() || null
})
